import { ClockCircleOutlined, EnvironmentOutlined, IdcardOutlined, UserOutlined } from "@ant-design/icons"
import { Col, Row, Space, Typography } from "antd"
import PropTypes from "prop-types"
import { formatExperienceTermsFull } from "utils/experience"
const { Text } = Typography
export const PreviewAddress = ({ trip, t, embedded }) => {
  // No own loader watcher — every parent (wizard layout, ListingPreview,
  // Embedded ExperienceDetail) already renders its own loader, so registering
  // one here just produced a second overlapping spinner.
  const { address, min_guests, max_guests, licenses_required } = trip

  return (
    <Row align="bottom" style={{ marginTop: embedded ? 5 : 24, marginBottom: 9, overflowX: "auto" }} gutter={30}>
      {address && (
        <Col span={24}>
          <Space align="center">
            <EnvironmentOutlined />
            <Text>{address}</Text>
          </Space>
        </Col>
      )}
      {min_guests && max_guests && (
        <Col span={24}>
          <Space align="center">
            <UserOutlined />
            <Text>{min_guests + "–" + max_guests} people</Text>
          </Space>
        </Col>
      )}
      {licenses_required && (
        <Col span={24}>
          <Space align="center">
            <IdcardOutlined />
            <Text>{t("trip.labels.licenses_required")}</Text>
          </Space>
        </Col>
      )}
      <Col span={24}>
        <Space align="center">
          <ClockCircleOutlined />
          <Text>{formatExperienceTermsFull(trip, t)}</Text>
        </Space>
      </Col>
    </Row>
  )
}

PreviewAddress.propTypes = {
  trip: PropTypes.shape({
    address: PropTypes.string,
    min_guests: PropTypes.number,
    max_guests: PropTypes.number,
    licenses_required: PropTypes.bool,
    available_hours_range: PropTypes.string,
    duration_type: PropTypes.string,
    duration_value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }).isRequired,
  t: PropTypes.func.isRequired,
  embedded: PropTypes.bool
}
